import React from 'react';
import LOOKUP from 'constants/lookup';
import { mapWarehouseFilter } from 'utils/mappers';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import NumberInput from 'screens/components/basic/NumberInput';



const searchFields = ({ pageName, warehouses, categories, species, cleanSearch, search, cleanOnHold, onHold, isVape = false }) => {
    let warehouseOptions = mapWarehouseFilter(warehouses);
    warehouseOptions.unshift({ text: "All", value: "0" });
    return (
        <div className="row m-0">
            {/*Search Inputs*/}
            <div className="row m-0">
                <div className="col-6 col-sm-3">
                    <TextInput
                        name={`${pageName}SkuNumberFilter`}
                        className="search-field"
                        label="SKU"
                        floatingLabelText="SKU"
                        hintText="SKU"
                        onPressKey={search} />
                </div>
                <div className="col-6 col-sm-3">
                    <TextInput
                        name={`${pageName}NameFilter`}
                        className="search-field"
                        label="Name"
                        floatingLabelText="Name"
                        hintText="Name"
                        maxLength={60}
                        onPressKey={search} />
                </div>
                <div className="col-6 col-sm-3">
                    <SelectInput name={`${pageName}Category`}
                        label={LOOKUP.product.filters.category.label}
                        className="search-field"
                        floatingLabelText={LOOKUP.product.filters.category.label}
                        hintText={LOOKUP.product.filters.category.hintText}
                        options={categories}
                        defaultValue="0"
                    />
                </div>
                <div className="col-6 col-sm-3">
                    <NumberInput name={`${pageName}Quantity`}
                        className="search-field"
                        hintText={'Quantity less than'}
                        floatingLabelText={'Quantity less than'}
                        type="number"
                        fullWidth={true}
                        label={'Quantity less than'}
                        min={0} />
                </div>
            </div>
            <div className="row m-0">
                <div className="col-6 col-sm-3">
                    <SelectInput
                        name={`${pageName}Warehouse`}
                        className="search-field"
                        label="Warehouse"
                        floatingLabelText="Warehouse"
                        options={warehouseOptions}
                        defaultValue="0" />
                </div>
                <div className="col-6 col-sm-3">
                    <TextInput
                        name={`${pageName}Brand`}
                        className="search-field"
                        label={LOOKUP.product.filters.brand.label}
                        floatingLabelText={LOOKUP.product.filters.brand.label}
                        hintText={LOOKUP.product.filters.brand.hintText}
                        maxLength={60}
                        onPressKey={search} />
                </div>
                {isVape ? null : (
                    <div className="col-6 col-sm-3">
                        <SelectInput name={`${pageName}Species`}
                            label={LOOKUP.product.filters.species.label}
                            className="search-field"
                            floatingLabelText={LOOKUP.product.filters.species.label}
                            hintText={LOOKUP.product.filters.species.hintText}
                            options={species}
                            defaultValue="0"
                        />
                    </div>
                )}
                <div className="col-6 col-sm-3">
                    <SelectInput name={`${pageName}OnHold`}
                        label={LOOKUP.product.filters.onHold.label}
                        className="search-field"
                        floatingLabelText={LOOKUP.product.filters.onHold.label}
                        hintText={LOOKUP.product.filters.onHold.hintText}
                        options={onHold}
                        defaultValue="0"
                    />
                </div>
            </div>
            {/*Buttons*/}
            <div className="row m-0 mt-2 search-buttons">
                <div className='col-lg-12 col-md-12 d-flex pb-2 justify-content-end'>
                    <Button
                        type="IconSearchButton"
                        label={LOOKUP.cashregister.filters.filterButton}
                        id="searchWarehouse"
                        onTouchTap={search}
                        className="btnNewBrandPOS mx-1"
                    />
                    <Button
                        className="btnCleanSearch  mx-1"
                        type="IconClearButton"
                        label={LOOKUP.cashregister.filters.cleanFilterButton}
                        onTouchTap={cleanSearch}
                    />
                    <Button
                        type="IconClearButton"
                        label={"Clear All OnHold Products"}
                        id="clearAllOnhold"
                        onTouchTap={cleanOnHold}
                        className="btnCleanSearch  mx-1"
                    />
                </div>
            </div>
        </div>
    );
};


export default searchFields;